import styled from 'styled-components';
import { ReactSVG } from 'react-svg';
import { mediaBreakpointUp, mediaBreakpointDown } from '../../styles/grid';

export const Container = styled.div`
  position: relative;

  ${mediaBreakpointUp.md} {
    margin: 10px 0px;
    display: flex;

    div:first-child {
      padding-left: 0;
    }

    div:last-child {
      padding-right: 0;
    }
  }
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
`;

export const ImageWrapper = styled.div`
  padding: 5px 0px;
  flex: 1;

  ${mediaBreakpointUp.md} {
    padding: 10px;
  }
`;

export const ContactSupportIconWrapper = styled.div`
  position: absolute;
  right: 10px;
  bottom: 50px;

  * {
    fill: ${({ theme }) => theme.configs.CTAButton.bgColor};
  }

  g {
    stroke: ${({ theme }) => theme.configs.CTAButton.fontColor};
  }

  ${mediaBreakpointDown.sm} {
    right: 0;
  }
`;

export const ContactSupportIcon = styled(ReactSVG)``;
